import { Fragment } from 'react'
import { blockRegistry } from './blockRegistry'
import { ContentBlock } from '@app/components/Guide/types/guide.types'

interface BlockRendererProps {
  blocks?: ContentBlock[] | null
}

export const BlockRenderer = ({ blocks }: BlockRendererProps) => {
  if (!blocks?.length) return null

  // heading renders right above it - for references block only
  const firstReferencesIndex = blocks.findIndex(
    (block) => block.__component === 'content.references',
  )

  return (
    <>
      {blocks.map((block, index) => {
        const Block = blockRegistry[block.__component as string]
        if (!Block) return null

        return (
          <Fragment key={block.id ?? index}>
            {index === firstReferencesIndex && (
              <h3 className="scroll-mt-[70px] text-xl font-bold leading-[150%] tracking-[0.32px] text-foreground">
                References:
              </h3>
            )}
            <Block block={block} />
          </Fragment>
        )
      })}
    </>
  )
}

export default BlockRenderer
